import { render, staticRenderFns } from "./MessageSendStatusPill.vue?vue&type=template&id=50e768e4&scoped=true"
import script from "./MessageSendStatusPill.vue?vue&type=script&lang=js"
export * from "./MessageSendStatusPill.vue?vue&type=script&lang=js"
import style0 from "./MessageSendStatusPill.vue?vue&type=style&index=0&id=50e768e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e768e4",
  null
  
)

export default component.exports